<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.sharedStatus"
        placeholder="共享状态"
      >
        <el-option
          v-for="(item, i) in sharedStatus"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="在线状态"
      >
        <el-option
          v-for="(item, i) in onlineList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.displayClientTypes"
        placeholder="展示终端"
        multiple
      >
        <el-option
          v-for="(item, i) in typeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.bannerTitle"
        placeholder="图片标题"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import qs from "qs";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {
        displayClientTypes: [],
      },
      onlineList: [],
      typeList: [],
      sharedStatus: [],
    };
  },
  created() {
    this.getSysParamByTypes(["ONLINE_STATUS", "CLIENT_TYPE_BANNER", "SHARED_SCREEN_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ONLINE_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["CLIENT_TYPE_BANNER"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["SHARED_SCREEN_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.onlineList = res.data["ONLINE_STATUS"] || [];
        this.typeList = res.data["CLIENT_TYPE_BANNER"] || [];
        this.sharedStatus = res.data["SHARED_SCREEN_STATUS"] || [];
      });
    },
    initData() {
      if (this.filters.displayClientTypes.includes("")) {
        delete this.filters.displayClientTypes;
        this.$emit("search", { ...this.filters, t: new Date().getTime() });
        return;
      }

      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {
        displayClientTypes: []
      };
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select__tags {
  overflow: hidden;
  span {
    display: flex;
  }
}
</style>
